import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {LoadingPage} from 'shells/loading-page/loading-page';

import type {Audience as AudienceFragment} from 'nutshell-graphql-types';

import type {ReportURLParams} from '../../../reports/report-types';

import {getSelectedFields} from '../helpers';

import {AudienceMemberListContainer} from './audience-member-list-container';

type Props = {
    audience: AudienceFragment | null | undefined;
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'contacts'>;
    onRemoveAllFilters: () => void;
    showFooter: boolean;
};

export function AudienceMemberList(props: Props) {
    if (!props.audience) {
        return <LoadingPage />;
    }

    const listParams = props.urlParams.list || {};
    const search = props.urlParams.q || '';

    return (
        <div className='routed-report-content' id='audience-member-list'>
            <AudienceMemberListContainer
                audienceId={props.audience.id}
                audienceName={props.audience.name}
                isWebFxAudience={props.audience.isWebFX}
                filters={props.activeFilters}
                search={search}
                selectedPage={
                    // @ts-expect-error
                    listParams.page && Number(listParams.page) ? Number(listParams.page) : 1
                }
                unfilteredCount={props.audience.membershipStats.totalCount.value}
                onRemoveAllFilters={props.onRemoveAllFilters}
                // @ts-expect-error
                selectedSortField={listParams.sort}
                selectedFields={getSelectedFields(props.urlParams)}
                onParamChange={props.onParamChange}
                urlParams={props.urlParams}
                hasPeopleListFooter={props.showFooter}
            />
        </div>
    );
}
